import PartnersApi from 'client/api/v2/PartnersApi';
import PartnersConstants from 'client/util/Constants/PartnersConstants';
import Vue from 'vue';

const { partnerNames, statuses } = PartnersConstants;

const settingsModule = 'SettingsModule';

const initialState = () => ({
  error: false,
  partners: [],
});

export default {
  namespaced: true,

  state: initialState(),

  actions: {
    async fetchPartners({ commit }) {
      try {
        const resp = await PartnersApi.fetch();
        commit('SET_PARTNERS', resp.results);
        commit('SET_ERROR', false);
      } catch (e) {
        commit('SET_ERROR', true);
      }
    },

    async allowPartnerLink({ commit }, id) {
      try {
        const resp = await PartnersApi.allowLink(id);
        const partner = resp.data;
        commit('UPDATE_PARTNER', { ...partner });
        commit('SET_ERROR', false);
      } catch (e) {
        commit('SET_ERROR', true);
      }
    },

    async denyPartnerLink({ commit }, id) {
      try {
        const resp = await PartnersApi.denyLink(id);
        const partner = resp.data;
        commit('UPDATE_PARTNER', { ...partner });
        commit('SET_ERROR', false);
      } catch (e) {
        commit('SET_ERROR', true);
      }
    },
  },

  mutations: {
    SET_PARTNERS(state, partners) {
      Vue.set(state, 'partners', partners);
    },

    SET_ERROR(state, error) {
      Vue.set(state, 'error', error);
    },

    UPDATE_PARTNER(state, updatedPartner) {
      const partners = [
        ...state.partners.filter(partner => partner.id !== updatedPartner.id),
        updatedPartner,
      ];

      Vue.set(state, 'partners', partners);
    },
  },

  getters: {
    hasActiveCrowdStrikeLink(state, _, rootState) {
      const { user } = rootState[settingsModule];
      const crowdStrikeLink = state.partners.find(
        (partner) => {
          const partnerIsCrowdStrike = partner.name.toLowerCase() === partnerNames.crowdStrike;

          const inValidStatus = [
            statuses.inTrial,
            statuses.purchased,
            statuses.suspended,
          ].includes(partner.status);

          // Race condition for new orgs:
          // After the account is verified, admin is redirected to Discover Page
          // There might be a little gap where partners service takes more time
          // to handle account verification, admin could still be on pending status
          // and see the wrong Discover Page
          // This check will allow new admins to see the CS Discover page
          // in case partners service is still handling transition from pending to in_trial
          const inPendingAndFirstSession = partner.status === statuses.pending
            && user.sessionCount === 1;

          return partnerIsCrowdStrike && (inValidStatus || inPendingAndFirstSession);
        },
      );

      return !!crowdStrikeLink;
    },

    hasPendingCrowdStrikeTrial(state, _, rootState) {
      const { user } = rootState[settingsModule];
      return !!state.partners.find(
        (partner) => partner.name.toLowerCase() === partnerNames.crowdStrike
        && partner.status === statuses.pending && user.sessionCount !== 1,
      );
    },
  },
};
